import styled from 'styled-components';
import { ModalTitle } from '../../Modal/Modal.styled';
import { COLORS } from '../../../styles/constants/colors';
import { ButtonWrapper } from '../../button/Button.styled';

const ReinitializePopupWrapper = styled.div`
  position: relative;
  width: 600px;
  max-width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 20px;
  color: ${COLORS.DARK_BLUE};

  ${ModalTitle} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 30px;
    background: ${COLORS.LIGHT_BLUE}80;
    gap: 20px;

    p {
      margin: 0;
      flex: 1;
    }
  }

  .content {
    padding: 10px 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    p {
      margin: 0;
      flex: 1;
    }

    ${ButtonWrapper} {
      margin: 0 auto;
    }
  }
`;

export { ReinitializePopupWrapper };
